import {
  all,
  fork,
  put,
  select,
  takeEvery,
} from 'redux-saga/effects';
import { Pagination } from '../../../core/types/data';
import { performApiPost } from '../../../core/utils/sagaUtils';
import { ApplicationState } from '../../types';
import { LoginActionConstants, LoginInfo } from '../login/types';
import { requestRequestList, setRequestList } from './actions';
import {
  RequestListResult,
  RequestRequestListArgs,
  ResultAction,
  ResultActionConstants,
  SearchFilter,
  SetSearchFilterArgs,
} from './types';

function* initializeFlow() {
  yield takeEvery(ResultActionConstants.INITIALIZE, function* _() {
    const filter: SearchFilter = yield select(
      (state: ApplicationState) => state.result.currentFilter,
    );
    const pagination: Pagination = yield select(
      (state: ApplicationState) => state.result.currentPagination,
    );

    if (window.authToken) {
      yield put(requestRequestList({
        options: {
          filter,
          pagination,
        },
      }));
    }

    yield takeEvery(LoginActionConstants.LOGIN_SESSION_SET, function* __() {
      yield put(requestRequestList({
        options: {
          filter,
          pagination,
        },
      }));
    });
  });
}

function* requestRequestListFlow() {
  yield takeEvery(ResultActionConstants.REQUEST_LIST_REQUEST,
    function* _(act: ResultAction<RequestRequestListArgs>) {
      const loginStatus: LoginInfo = yield select(
        (state: ApplicationState) => state.login.loginStatus,
      );

      if (loginStatus) {
        yield fork((
          payload,
          page,
          pageSize,
          mode: string,
        ) => performApiPost<RequestListResult>(
          'v1/Result/GetRequestList', {
            payload: {
              ...payload,
              mode,
            },
            params: {
              page,
              pageSize,
            },
            onResult: ({ result, error }) => put(setRequestList({
              requestListResult: result,
              error,
            })),
          },
        ),
        act.options.filter,
        act.options.pagination.currentPage,
        act.options.pagination.pageSize,
        loginStatus.data?.mode || '');
      }
    });
}

function* requestRequestListFilterFlow() {
  yield takeEvery(ResultActionConstants.SEARCH_FILTER_SET,
    function* _(act: ResultAction<SetSearchFilterArgs>) {
      const filter: SearchFilter = yield select(
        (state: ApplicationState) => state.result.currentFilter,
      );
      const pagination: Pagination = yield select(
        (state: ApplicationState) => state.result.currentPagination,
      );

      if (act.toRequest) {
        yield put(requestRequestList({
          options: {
            filter,
            pagination,
          },
        }));
      }
    });
}

export default function* resultSaga() {
  yield all([
    initializeFlow(),
    requestRequestListFlow(),
    requestRequestListFilterFlow(),
  ]);
}
